import { render, staticRenderFns } from "./CodigoEtica.vue?vue&type=template&id=9e010ad4"
import script from "./CodigoEtica.vue?vue&type=script&lang=js"
export * from "./CodigoEtica.vue?vue&type=script&lang=js"
import style0 from "./CodigoEtica.vue?vue&type=style&index=0&id=9e010ad4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports